// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPanelItem_container__WJqbb","title":"MainPanelItem_title__GssXi","close":"MainPanelItem_close__RD0Ml"};